import { MessagesEnum } from 'app/shared/enums';
import { ShortPathSectionMessage } from 'app/components/ShortPathSectionMessage';
import { CalculationDataFoundMessageBox } from 'app/components/CalculationDataFoundMessageBox';
import { EnterVehicleDataManuallyMessageBox } from 'app/components/EnterVehicleDataManuallyMessageBox';

export const customFormSectionMessage = {
  [MessagesEnum.MatchingQuotationDataFound]: ShortPathSectionMessage,
  [MessagesEnum.CalculationDataFound]: CalculationDataFoundMessageBox,
  [MessagesEnum.EnterVehicleDataManually]: EnterVehicleDataManuallyMessageBox,
};
